export const merchantHelpSupportCardClass =
  'rounded-merchant-stat bg-merchant-surface shadow-merchant-stat'

export const merchantHelpSupportFieldClass =
  'w-full rounded-lg border border-merchant-divider bg-merchant-surface px-4 py-3 text-sm text-merchant-ink outline-none transition-colors placeholder:text-merchant-muted/70 focus:border-merchant-primary focus:ring-2 focus:ring-merchant-primary/10'

export const merchantHelpSupportLabelClass =
  'text-[11px] font-semibold uppercase tracking-[0.08em] text-merchant-muted'
